import './CreateTransaction.css';
import { Segment } from 'semantic-ui-react';
import MerchantSelector from '../../closedLoop/MerchantSelector';

export default function MerchantSelection() {
  return (
    <Segment style={{ height: '100px' }}>
      <h2 className="ui header">Merchant</h2>
      <div className="ui grid" style={{paddingTop: '5px'}}>
      <div className="field">
            <MerchantSelector />
      </div>
      </div>
    </Segment>
  );
}
